// needs-decision-question-ticket-match.ts — V2-0 (spec V2 §4.0, plan
// 20261006-1008 phase-01).
//
// "Câu hỏi này của ticket nào?" — một nguồn cho gate dispatch, router
// needs_decision và mục prompt "Quyết định đã chốt".
//
// Vì sao không còn `endsWith("-needs-decision")`: id nay mang hậu tố nội dung
// `-<sha8>`, nên hậu tố cũ không còn nhận ra câu của ticket — câu của T-1 sẽ
// rơi về "câu của cả mission" và chặn mọi ticket. Và vì sao không lọc prefix:
// `T-10-needs-decision` BẮT ĐẦU bằng `T-1` — prefix trộn câu/answer hai ticket.
import type { InterviewQuestion } from "./schemas/interview-schema.js";

/** Nguyên id: `<ticket>-needs-decision` (v1, không hash) hoặc `…-<sha8>` (V2-0). */
const NEEDS_DECISION_ID = /^(.+)-needs-decision(?:-[0-9a-f]{8})?$/;

/**
 * Ticket sở hữu câu hỏi, đọc từ NGUYÊN id; `undefined` = câu của CẢ MISSION
 * (Clarify viết tay, id tự do như `q-env`) — không bao giờ bị lọc theo ticket.
 * Không có field `ticket_id` trong interview.json (xem `needsDecisionQuestionId`).
 */
export function needsDecisionQuestionTicket(
  question: Pick<InterviewQuestion, "id">,
): string | undefined {
  return NEEDS_DECISION_ID.exec(question.id)?.[1];
}

/** Câu này có phải câu `needs_decision` của đúng `ticketId` không (so khớp chính xác). */
export function isNeedsDecisionQuestionOfTicket(
  question: Pick<InterviewQuestion, "id">,
  ticketId: string,
): boolean {
  return needsDecisionQuestionTicket(question) === ticketId;
}
